<template>
<header ref="headerMenu" style="z-index: 999">
  <HamburgerMenu
      :class="hamburgerProps ? '' : 'hidden'"
      @toggleHamburgerMenu="toggleHamburger"
      class="hamburgerMenu"
  />
  <Logo class="logo"/>
  <SearchMenu
      :class="visibility? '' : 'hidden'"
      :refinedPatientListProps="refinedPatientList"
      class="search"
  />
  <MenuList
      :visibilityProps="visibility"
      :readProps="read"
      class="menu-list"
  />
  <Contact
      :class="visibility? '' : 'hidden'"
  />
</header>
</template>
<script>
import _API from "@/api";
import SearchMenu from './SearchMenu/index';
import {mapActions, mapGetters} from 'vuex';
import HamburgerMenu from "./hamburgerMenu";
import Logo from './logo';
import MenuList from './menuList';
import Contact from './contact';

export default {
  name: 'HeaderMenu',
  props: [
    'patientName',
    'pageNavHome',
    'hamburgerProps'
  ],
  components: {
    MenuList,
    HamburgerMenu,
    Logo,
    SearchMenu,
    Contact
  },
  data() {
    return {
      active: false,
      read: undefined,
      isHamburgerVisible: false,
      refinedPatientList: [],
      patientList: [],
      visibility: true,
    }
  },
  methods: {
    ...mapActions(['setHamburgerVisible', 'logOut', 'changeNotificationsReadStatus']),
    ...mapGetters(['getIsHamburgerVisible', 'getAuth', 'getPatientList']),
    toggleHamburger() {
      this.setHamburgerVisible(!this.isHamburgerVisible);
      this.$modal.show('blank-modal');
    },
    makeSelectBoxKeyRange() {
      for (let i = 0; i < this.patientList.length; i++) {
        const item = {};
        item.no = i + 1;
        item.key = i + 1;
        item.title = this.patientList[i].patientInfo.patientInfoName;
        item.seqPatient = this.patientList[i].seqPatient;
        item.patientName = this.patientList[i].patientInfo.patientInfoName;
        item["userName"] = this.patientList[i].userName;
        item.patientEmail = this.patientList[i].patientEmail;
        item.patientInfoBirth = this.patientList[i].patientInfo.patientInfoBirth;
        item.patientInfoGender = this.patientList[i].patientInfo.patientInfoGender;
        item.patientInfoImageUrl = this.patientList[i].patientInfo.patientInfoImageUrl;
        this.refinedPatientList.push(item);
      }
    },
    async checkForUnreadNotification() {
      const boolean = await this.$fbConf.CHECK_FOR_UNREAD_NOTI();
      this.changeNotificationsReadStatus(boolean);
    },
  },
  created() {
    if (this.$route.path.includes('payments')) {
      this.visibility = false;
    }
    this.isHamburgerVisible = this.getIsHamburgerVisible();
    this.checkForUnreadNotification();

    _API.PATIENT_LIST.getMyPatientsAndReservedSchedulesForToday()
        .then(res => {
          if (res.data.isSuccess && res.data.failedCode === '0') {
            this.$store.dispatch(`initPatientListAndScheduleList`, {
              patientList: res.data.patientList, scheduleList: res.data.scheduleList
            }).then(_ => {
              this.patientList = res.data.patientList;
            })
          }
        })

    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      if (this.patientList !== state.patientList) {
        this.patientList = state.patientList;
      }
      this.read = state.isUnreadNotifications;
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  watch: {
    patientList: {
      deep: true,
      handler(newVal) {
        this.patientList = newVal;
        this.refinedPatientList = [];
        this.makeSelectBoxKeyRange();
      }
    },
    $route: {
      deep: true,
      handler(newVal) {
        this.visibility = !newVal.path.includes('payments');
      }
    }
  }
}
</script>
<style lang="scss">
.search {
  .vs__dropdown-menu {
    max-height: 310px;
  }
}
</style>